import { gql, useMutation } from "@apollo/client";

const SAVE_PRODUCT_QUESTION_DOC=gql`
mutation SaveProductQuestionDocument($orderId: Int, $token: String, $answerFile: Upload) {
    saveProductQuestionDocument(orderId: $orderId, token: $token, answerFile: $answerFile) {
      success
      message
      data {
        orderId
      }
    }
  }
`;

export const SaveProductQuestionDocument=()=>{
    const [
        saveProductQuestionDocResponseFunction,
        saveProductQuestionDocResponseData
    ]=useMutation(SAVE_PRODUCT_QUESTION_DOC)

    const saveProductQuestionDocQueryData=saveProductQuestionDocResponseData;

    const initSaveProductQuestionDocData=(data, successCallback, errorCallback)=>{
        saveProductQuestionDocResponseFunction({
            variables:data
        }).then((responseData)=>{
            if(responseData?.data?.saveProductQuestionDocument?.success){
                successCallback(responseData)
            }else{
                errorCallback(responseData)
            }
        }).catch((error)=>{
            errorCallback(error)
        })
    }
    return {initSaveProductQuestionDocData,saveProductQuestionDocQueryData}
}